export default "__VITE_ASSET__bwlflCW4__"